import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CountdownTimer({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState(calc());

  function calc() {
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / 1000 / 60) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calc()), 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDate]);

  const blocks = [
    { value: timeLeft.days, label: "Días", color: "#00E5FF" },
    { value: timeLeft.hours, label: "Horas", color: "#7B5EA7" },
    { value: timeLeft.minutes, label: "Min", color: "#6B7FD7" },
    { value: timeLeft.seconds, label: "Seg", color: "#F5A623" },
  ];

  return (
    <div data-testid="countdown-timer" className="flex items-center gap-3 sm:gap-4 md:gap-5">
      {blocks.map((block, i) => (
        <div key={block.label} className="flex items-center gap-3 sm:gap-4 md:gap-5">
          <div className="flex flex-col items-center">
            <div
              data-testid={`countdown-${block.label.toLowerCase()}`}
              className="relative w-16 h-16 sm:w-18 sm:h-18 md:w-22 md:h-22 flex items-center justify-center rounded-xl glass-card-strong overflow-hidden group border-glow-cycle"
            >
              {/* Top shine */}
              <div className="absolute top-0 left-0 right-0 h-px" style={{ background: `linear-gradient(90deg, transparent, ${block.color}40, transparent)` }} />
              {/* Inner gradient */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/[0.02] to-transparent" />

              <AnimatePresence mode="popLayout">
                <motion.span
                  key={block.value}
                  initial={{ y: -20, opacity: 0, scale: 0.8 }}
                  animate={{ y: 0, opacity: 1, scale: 1 }}
                  exit={{ y: 20, opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="relative text-2xl sm:text-3xl md:text-3xl font-semibold text-white tabular-nums"
                  style={{ fontVariantNumeric: "tabular-nums" }}
                >
                  {String(block.value).padStart(2, "0")}
                </motion.span>
              </AnimatePresence>
            </div>
            <span className="mt-2 text-[9px] sm:text-[10px] uppercase tracking-[0.25em]" style={{ color: `${block.color}60` }}>
              {block.label}
            </span>
          </div>
          {i < blocks.length - 1 && (
            <span className="text-lg text-white/10 font-extralight mt-[-18px]">:</span>
          )}
        </div>
      ))}
    </div>
  );
}
